import Cookies from "js-cookie";

export const logout = () => {
   try {
    const project = Cookies.get("test_engine_project");

    // IMPORTANT: redirect FIRST
    if (project) {
      window.location.replace(`/${project}/login`);
    } else {
      window.location.replace("/login");
    }

    //  cleanup AFTER redirect scheduled
    setTimeout(() => {
      sessionStorage.clear();
      localStorage.clear();
      Cookies.remove("test_engine_project");
    }, 0);

    return { status: 200 };
  } catch (error) {
    console.error("Logout failed:", error);
    return { status: 500 };
  }
};
